import { round } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { currencyFormat, getLocalizationContext } from '@fiverr-private/localization';
import { Currency } from '../../../../types/currency';
import { formatNumberWithComma } from './shared';

const DEFAULT_CURRENCY = 'USD';

export const getCentsInCurrency = (usdCents: number, currency?: Currency, formatWithCommas = false) => {
    const amountInDollars = usdCents / 100;
    const value = round(currency?.rate ? amountInDollars * currency?.rate : amountInDollars);
    if (formatWithCommas) {
        return formatNumberWithComma(value);
    }
    return value;
};

export const centsToCurrency = (usdCents: number, currency?: Currency) => {
    const { currency: _contextCurrency = DEFAULT_CURRENCY } = getContext();
    const localizationContext = getLocalizationContext();
    const contextCurrency = _contextCurrency ? _contextCurrency : DEFAULT_CURRENCY;
    const amountInDollars = usdCents / 100;
    const fallbackValue = `$${amountInDollars.toFixed(0)}`;

    const value = getCentsInCurrency(usdCents, currency);

    if (!currency || !currency.rate) return fallbackValue;

    const currencyCode = currency?.name || contextCurrency;

    return currencyFormat({
        localizationContext,
        value,
        currencyCode,
        options: {
            fallbackValue,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
    });
};

export const currencyToCents = (value: number, rate: number): number => (value / rate) * 100;
